import { ChatBanner } from "./ChatBanner";

export function BranchLiveNudge({
  show,
  onGoLive,
}: {
  show: boolean;
  onGoLive: () => void;
}) {
  return (
    <ChatBanner
      show={show}
      icon="info"
      message="You’re viewing a branch"
      buttonLabel="Go to live"
      onButtonClick={onGoLive}
    />
  );
}
